module.exports = __webpack_public_path__ + "static/media/salmantina_int.1857d9b5.png";